import { Skeleton } from "@/components/ui/skeleton";

const AccountPage = () => {
  return (
    <div className="p-6">
      <Skeleton className="flex items-center justify-center h-96 text-gray-500">
        🚧 [WIP] Mon compte
      </Skeleton>
    </div>
  );
};

export default AccountPage;
